// augment Sylvester some
Matrix.Translation = function (v) {
  if (v.elements.length == 2) {
    var r = Matrix.I(3);
    r.elements[2][0] = v.elements[0];
    r.elements[2][1] = v.elements[1];
    return r;
  }

  if (v.elements.length == 3) {
    var r = Matrix.I(4);
    r.elements[0][3] = v.elements[0];
    r.elements[1][3] = v.elements[1];
    r.elements[2][3] = v.elements[2];
    return r;
  }

  throw "Invalid length for Translation";
};

Matrix.unflatten4x4 = function (array) {
  var k, m;
  m = [];
  for (var k = 0; k < 4; k++) m[k] = array.slice(k * 4, (k + 1) * 4);

  return $M(m).transpose();
};

Matrix.unflatten3x3 = function (array) {
  var k, m;
  m = [];
  for (var k = 0; k < 3; k++) m[k] = array.slice(k * 3, (k + 1) * 3);

  return $M(m).transpose();
};

Matrix.prototype.flatten = function () {
  var result = [];
  if (this.elements.length == 0) return [];

  for (var j = 0; j < this.elements[0].length; j++)
    for (var i = 0; i < this.elements.length; i++)
      result.push(this.elements[i][j]);
  return result;
};

Matrix.prototype.ensure4x4 = function () {
  if (this.elements.length == 4 && this.elements[0].length == 4) return this;

  if (this.elements.length > 4 || this.elements[0].length > 4) return null;

  for (var i = 0; i < this.elements.length; i++) {
    for (var j = this.elements[i].length; j < 4; j++) {
      if (i == j) this.elements[i].push(1);
      else this.elements[i].push(0);
    }
  }

  for (var i = this.elements.length; i < 4; i++) {
    if (i == 0) this.elements.push([1, 0, 0, 0]);
    else if (i == 1) this.elements.push([0, 1, 0, 0]);
    else if (i == 2) this.elements.push([0, 0, 1, 0]);
    else if (i == 3) this.elements.push([0, 0, 0, 1]);
  }

  return this;
};

Matrix.prototype.make3x3 = function () {
  if (this.elements.length != 4 || this.elements[0].length != 4) return null;

  return Matrix.create([
    [this.elements[0][0], this.elements[0][1], this.elements[0][2]],
    [this.elements[1][0], this.elements[1][1], this.elements[1][2]],
    [this.elements[2][0], this.elements[2][1], this.elements[2][2]],
  ]);
};

Vector.prototype.flatten = function () {
  return this.elements;
};

// 4x4 matrix inverse
Matrix.prototype._inverse4x4 = function () {
  src = this.flatten();
  var tmp = new Array(12);
  var dst = new Array(16);
  var det;

  /* calculate pairs for first 8 elements (cofactors) */
  tmp[0] = src[10] * src[15];
  tmp[1] = src[11] * src[14];
  tmp[2] = src[9] * src[15];
  tmp[3] = src[11] * src[13];
  tmp[4] = src[9] * src[14];
  tmp[5] = src[10] * src[13];
  tmp[6] = src[8] * src[15];
  tmp[7] = src[11] * src[12];
  tmp[8] = src[8] * src[14];
  tmp[9] = src[10] * src[12];
  tmp[10] = src[8] * src[13];
  tmp[11] = src[9] * src[12];

  /* calculate first 8 elements (cofactors) */
  dst[0] = tmp[0] * src[5] + tmp[3] * src[6] + tmp[4] * src[7];
  dst[0] -= tmp[1] * src[5] + tmp[2] * src[6] + tmp[5] * src[7];
  dst[1] = tmp[1] * src[4] + tmp[6] * src[6] + tmp[9] * src[7];
  dst[1] -= tmp[0] * src[4] + tmp[7] * src[6] + tmp[8] * src[7];
  dst[2] = tmp[2] * src[4] + tmp[7] * src[5] + tmp[10] * src[7];
  dst[2] -= tmp[3] * src[4] + tmp[6] * src[5] + tmp[11] * src[7];
  dst[3] = tmp[5] * src[4] + tmp[8] * src[5] + tmp[11] * src[6];
  dst[3] -= tmp[4] * src[4] + tmp[9] * src[5] + tmp[10] * src[6];
  dst[4] = tmp[1] * src[1] + tmp[2] * src[2] + tmp[5] * src[3];
  dst[4] -= tmp[0] * src[1] + tmp[3] * src[2] + tmp[4] * src[3];
  dst[5] = tmp[0] * src[0] + tmp[7] * src[2] + tmp[8] * src[3];
  dst[5] -= tmp[1] * src[0] + tmp[6] * src[2] + tmp[9] * src[3];
  dst[6] = tmp[3] * src[0] + tmp[6] * src[1] + tmp[11] * src[3];
  dst[6] -= tmp[2] * src[0] + tmp[7] * src[1] + tmp[10] * src[3];
  dst[7] = tmp[4] * src[0] + tmp[9] * src[1] + tmp[10] * src[2];
  dst[7] -= tmp[5] * src[0] + tmp[8] * src[1] + tmp[11] * src[2];

  /* calculate pairs for second 8 elements (cofactors) */
  tmp[0] = src[2] * src[7];
  tmp[1] = src[3] * src[6];
  tmp[2] = src[1] * src[7];
  tmp[3] = src[3] * src[5];
  tmp[4] = src[1] * src[6];
  tmp[5] = src[2] * src[5];
  tmp[6] = src[0] * src[7];
  tmp[7] = src[3] * src[4];
  tmp[8] = src[0] * src[6];
  tmp[9] = src[2] * src[4];
  tmp[10] = src[0] * src[5];
  tmp[11] = src[1] * src[4];

  /* calculate second 8 elements (cofactors) */
  dst[8] = tmp[0] * src[13] + tmp[3] * src[14] + tmp[4] * src[15];
  dst[8] -= tmp[1] * src[13] + tmp[2] * src[14] + tmp[5] * src[15];
  dst[9] = tmp[1] * src[12] + tmp[6] * src[14] + tmp[9] * src[15];
  dst[9] -= tmp[0] * src[12] + tmp[7] * src[14] + tmp[8] * src[15];
  dst[10] = tmp[2] * src[12] + tmp[7] * src[13] + tmp[10] * src[15];
  dst[10] -= tmp[3] * src[12] + tmp[6] * src[13] + tmp[11] * src[15];
  dst[11] = tmp[5] * src[12] + tmp[8] * src[13] + tmp[11] * src[14];
  dst[11] -= tmp[4] * src[12] + tmp[9] * src[13] + tmp[10] * src[14];
  dst[12] = tmp[2] * src[10] + tmp[5] * src[11] + tmp[1] * src[9];
  dst[12] -= tmp[4] * src[11] + tmp[0] * src[9] + tmp[3] * src[10];
  dst[13] = tmp[8] * src[11] + tmp[0] * src[8] + tmp[7] * src[10];
  dst[13] -= tmp[6] * src[10] + tmp[9] * src[11] + tmp[1] * src[8];
  dst[14] = tmp[6] * src[9] + tmp[11] * src[11] + tmp[3] * src[8];
  dst[14] -= tmp[10] * src[11] + tmp[2] * src[8] + tmp[7] * src[9];
  dst[15] = tmp[10] * src[10] + tmp[4] * src[8] + tmp[9] * src[9];
  dst[15] -= tmp[8] * src[9] + tmp[11] * src[10] + tmp[5] * src[8];

  /* calculate determinant */
  det = src[0] * dst[0] + src[1] * dst[1] + src[2] * dst[2] + src[3] * dst[3];

  /* calculate matrix inverse */
  det = 1.0 / det;
  for (var j = 0; j < 16; j++) dst[j] *= det;

  var k, m;
  m = [];
  for (var k = 0; k < 4; k++) m[k] = dst.slice(k * 4, (k + 1) * 4);
  return $M(m);
};

function mht(m) {
  var s = "";
  if (m.length == 16) {
    for (var i = 0; i < 4; i++) {
      s +=
        "<span style='font-family: monospace'>[" +
        m[i * 4 + 0].toFixed(4) +
        "," +
        m[i * 4 + 1].toFixed(4) +
        "," +
        m[i * 4 + 2].toFixed(4) +
        "," +
        m[i * 4 + 3].toFixed(4) +
        "]</span><br/>";
    }
  } else if (m.length == 9) {
    for (var i = 0; i < 3; i++) {
      s +=
        "<span style='font-family: monospace'>[" +
        m[i * 3 + 0].toFixed(4) +
        "," +
        m[i * 3 + 1].toFixed(4) +
        "," +
        m[i * 3 + 2].toFixed(4) +
        "]</font><br/>";
    }
  } else {
    return m.toString();
  }
  return s;
}

//
// gluLookAt
//
function makeLookAt(ex, ey, ez, cx, cy, cz, ux, uy, uz) {
  var eye = $V([ex, ey, ez]);
  var center = $V([cx, cy, cz]);
  var up = $V([ux, uy, uz]);

  var mag;

  var z = eye.subtract(center).toUnitVector();
  var x = up.cross(z).toUnitVector();
  var y = z.cross(x).toUnitVector();

  var m = $M([
    [x.e(1), x.e(2), x.e(3), 0],
    [y.e(1), y.e(2), y.e(3), 0],
    [z.e(1), z.e(2), z.e(3), 0],
    [0, 0, 0, 1],
  ]);

  var t = $M([
    [1, 0, 0, -ex],
    [0, 1, 0, -ey],
    [0, 0, 1, -ez],
    [0, 0, 0, 1],
  ]);
  return m.x(t);
}

//
// gluPerspective
//
function makePerspective(fovy, aspect, znear, zfar) {
  var ymax = znear * Math.tan((fovy * Math.PI) / 360.0);
  var ymin = -ymax;
  var xmin = ymin * aspect;
  var xmax = ymax * aspect;

  return makeFrustum(xmin, xmax, ymin, ymax, znear, zfar);
}

//
// glFrustum
//
function makeFrustum(left, right, bottom, top, znear, zfar) {
  var X = (2 * znear) / (right - left);
  var Y = (2 * znear) / (top - bottom);
  var A = (right + left) / (right - left);
  var B = (top + bottom) / (top - bottom);
  var C = -(zfar + znear) / (zfar - znear);
  var D = (-2 * zfar * znear) / (zfar - znear);

  return $M([
    [X, 0, A, 0],
    [0, Y, B, 0],
    [0, 0, C, D],
    [0, 0, -1, 0],
  ]);
}

//
// glOrtho
//
function makeOrtho(left, right, bottom, top, znear, zfar) {
  var tx = -(right + left) / (right - left);
  var ty = -(top + bottom) / (top - bottom);
  var tz = -(zfar + znear) / (zfar - znear);

  return $M([
    [2 / (right - left), 0, 0, tx],
    [0, 2 / (top - bottom), 0, ty],
    [0, 0, -2 / (zfar - znear), tz],
    [0, 0, 0, 1],
  ]);
}
